import { registerComponent } from '../lib/ComponentHelpers';
import RangedAttack from './RangedAttack';
import type { DisplayInfo } from '../types/Components';
import { HexOffset, HexOffsetSet, HexBearing } from '../grid';

const VENOM_PATTERN = HexOffsetSet.construct(
  HexOffsetSet.arc(2, HexBearing._S, HexBearing.R)
);

/**
 * A ranged attack that spits venom in a 5-hex arc at a distance of 2.
 */
class SpitVenom extends RangedAttack {
  constructor(data: { damage?: number, priority?: number } = {}) {
    super({
      damage: data.damage ?? 100,
      priority: data.priority ?? 30,
      rangePattern: VENOM_PATTERN,
    });
  }

  getDisplayInfo(): DisplayInfo {
    return { icon: 'game-icons:venom-bottle', label: 'Spit Venom', description: 'Ranged venom attack.' };
  }

  static getTestInstances(): SpitVenom[] {
    return [
      new SpitVenom({ damage: 100, priority: 30 }),
      new SpitVenom({ damage: 75, priority: 35 }),
      new SpitVenom({ damage: 50, priority: 25 }),
    ];
  }
}

export default registerComponent(SpitVenom);
